import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { Button } from '@studio/design-system/button';
import { Centered } from '@studio/design-system/overlay';
import { useState, type ReactElement } from 'react';

export const ElectronTest = (): ReactElement => {
  const [showAuth, setShowAuth] = useState(false);
  const { isAuthenticated, logout } = useAuth0();

  return (
    <Centered>
      <div className='h-[200px] w-[400px] bg-white p-16 text-black'>
        <div className='flex flex-col gap-4'>
          <div className='mb-12 text-xl'>Electron tests</div>
          <Button size='lg' onClick={() => {}}>
            Alert
          </Button>
          <Button size='lg' onClick={() => {}}>
            Open new window
          </Button>
          {!isAuthenticated ? (
            <Button
              onClick={() => {
                setShowAuth(true);
              }}
            >
              Authenticate ({window.location.href})
            </Button>
          ) : (
            <Button
              onClick={() => {
                logout({
                  logoutParams: {
                    returnTo: `${window.location.origin}/electron`
                  }
                });
              }}
            >
              Logout
            </Button>
          )}
          {showAuth && <ShowAuth />}
        </div>
      </div>
    </Centered>
  );
};

const ShowAuth = () => {
  const Wrapper = withAuthenticationRequired(() => <div>Authenticated!</div>, {
    onRedirecting: () => <div>Authenticating electron app</div>,
    returnTo: `${location.pathname}${location.search}`
  });
  return (
    <div>
      Logging in...
      <Wrapper />
    </div>
  );
};
